import { clsx } from 'clsx';

import { useTLang } from 'intl/intl';
import { ReactComponent as ProUserIcon } from 'assets/images/icons/prime.svg';
import { ReactComponent as NewUserIcon } from 'assets/images/icons/blue_star.svg';

import makeClasses from './UserTag.style';

import type { HTMLAttributes } from 'react';
import type { UserTagType } from 'shared/domain';

export function UserTag(props: Props) {
  const { variant = 'own', ...divProps } = props;

  const label = useTLang({
    id: {
      new: 'order.detail.clientModule.userTag.new',
      pro: 'order.detail.clientModule.userTag.pro',
      own: 'order.detail.clientModule.userTag.own',
    }[variant],
  });

  const _classes = makeClasses({ userTag: variant });

  return (
    <div
      role='term'
      className={clsx(_classes.root, divProps.className)}
      {...divProps}
    >
      {variant === 'new' && <NewUserIcon />}
      {variant === 'pro' && <ProUserIcon />}
      <span>{label}</span>
    </div>
  );
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  variant: UserTagType;
}
